import { useEffect, useState } from 'react'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import datasheetAttributes from 'core/common/constants/datasheetAttributes.json'
import i18n from 'core/common/i18n'
import Checkbox from 'core/components/Checkbox'
import {
  Divider,
  Button,
  Typography,
  FormControlLabel,
  IconButton,
  OutlinedInput,
  InputAdornment,
  Link,
} from 'core/components/Core'
import Modal from 'core/components/Modal'
import { useAppContext } from 'core/pages/ProductNew-v2/context/AppContext'

function ProductDialogSelectAttributes({
  open,
  onClose,
  handleAddSelectedAttributes,
  disableCreateAttribute,
}) {
  const { modalDataSheetFormValues } = useAppContext()
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredAttributes, setFilteredAttributes] = useState(
    (modalDataSheetFormValues?.length ? modalDataSheetFormValues : datasheetAttributes).map(
      attribute => ({
        ...attribute,
        selected: false,
        visible: true,
      })
    )
  )

  const [selectedAttributes, setSelectedAttributes] = useState([])
  const selectedAttributesCount = selectedAttributes.length

  useEffect(() => {
    const selectedFields = filteredAttributes.filter(attribute => attribute.selected)

    setSelectedAttributes(selectedFields)
  }, [filteredAttributes])

  const handleSearchChange = event => {
    const { value } = event.target
    setSearchTerm(value)

    if (value === '') {
      setFilteredAttributes(prevFilteredAttributes =>
        prevFilteredAttributes.map(attribute => ({
          ...attribute,
          visible: true,
        }))
      )
    } else {
      setFilteredAttributes(prevFilteredAttributes =>
        prevFilteredAttributes.map(attribute => ({
          ...attribute,
          visible: attribute.type.toLowerCase().startsWith(value.toLowerCase()),
        }))
      )
    }
  }

  const createNewAttribute = () => {
    const newAttribute = {
      type: searchTerm,
      value: '',
      selected: true,
      visible: true,
    }

    setFilteredAttributes([...filteredAttributes, newAttribute])
  }

  const handleOnChange = clickedAttribute => {
    setFilteredAttributes(prevFilteredAttributes => {
      return prevFilteredAttributes.map(attribute => {
        if (attribute === clickedAttribute) {
          return {
            ...attribute,
            selected: !attribute.selected,
          }
        }
        return attribute
      })
    })
  }

  const handleClear = () => {
    setSearchTerm('')

    setFilteredAttributes(prevFilteredAttributes =>
      prevFilteredAttributes.map(attribute => ({
        ...attribute,
        visible: true,
      }))
    )
  }

  const renderDatasheetAttributesList = () => (
    <div style={{ maxHeight: 390, overflow: 'auto' }}>
      {filteredAttributes
        .filter(attribute => attribute.visible)
        .sort((a, b) => a.type.localeCompare(b.type))
        .map(attribute => (
          <>
            <div className="d-flex justify-between align-center">
              <Typography variant="body1" className="py-1">
                {attribute.type}
              </Typography>
              <FormControlLabel
                control={<Checkbox />}
                name={attribute.type}
                onChange={() => handleOnChange(attribute)}
                checked={attribute.selected}
              />
            </div>
            <Divider />
          </>
        ))}
    </div>
  )

  const renderCreateAttributeOption = () => {
    const allAttributesHidden = filteredAttributes.every(attribute => !attribute.visible)

    if (!allAttributesHidden) return null

    return (
      <>
        <div className="d-flex justify-between align-center">
          <Typography variant="body1" className="py-2">
            {searchTerm}
          </Typography>

          <Link variant="button" onClick={createNewAttribute} className="cursor-pointer">
            Criar atributo
          </Link>
        </div>
        <Divider />
      </>
    )
  }

  return (
    <Modal
      title={
        <div className="d-flex justify-between">
          <Typography variant="h5">
            {i18n.t('productNew.productDialogDatasheet.title')}{' '}
            {!!selectedAttributesCount && `(${selectedAttributesCount})`}
          </Typography>

          <IconButton size="small" onClick={onClose}>
            <CloseOutlinedIcon />
          </IconButton>
        </div>
      }
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <OutlinedInput
        fullWidth
        hiddenLabel
        name="search"
        placeholder="Buscar"
        value={searchTerm}
        onChange={handleSearchChange}
        endAdornment={
          searchTerm && (
            <InputAdornment position="end" style={{ marginRight: -12 }}>
              <IconButton
                aria-label={i18n.t('product.productSearch.inputSearchDropdown.labelClear')}
                size="small"
                onClick={handleClear}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </InputAdornment>
          )
        }
      />

      <Divider className="mt-2" />

      {!disableCreateAttribute && renderCreateAttributeOption()}
      {renderDatasheetAttributesList()}

      <div className="mt-2 text-center">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleAddSelectedAttributes(
              selectedAttributes.map(({ type, value, typeSelection, values }) => ({
                type,
                value,
                typeSelection,
                values,
              }))
            )
            onClose()
          }}
        >
          {i18n.t('productNew.add')}
        </Button>
      </div>
    </Modal>
  )
}

export default ProductDialogSelectAttributes
